import React, { useEffect, useState } from "react";
import axios from "axios";
import "./contact.css";

// ---- Inline icons (no external icon library needed) ----
const iconBase = {
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.8,
  strokeLinecap: "round",
  strokeLinejoin: "round",
};

const BuildingIcon = ({ size = 22, className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" className={className} {...iconBase}>
    <rect x="4" y="2" width="16" height="20" rx="1" />
    <path d="M9 22v-4h6v4" />
    <path d="M8 6h.01M12 6h.01M16 6h.01M8 10h.01M12 10h.01M16 10h.01M8 14h.01M12 14h.01M16 14h.01" />
  </svg>
);

const PhoneIcon = ({ size = 20, className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" className={className} {...iconBase}>
    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.362 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.338 1.85.573 2.81.7A2 2 0 0 1 22 16.92Z" />
  </svg>
);

function Branches() {
  const [Address, setAddress] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          "https://cyberathon.com/NLF/index.php/Api/Nlf_Controller/list_contact_info"
        );
        setAddress(response.data.data || []);
      } catch (error) {
        console.error("Error fetching branch data:", error);
      }
    };
    fetchData();
  }, []);

  // Strip HTML/entities from the API text, then split off a trailing
  // phone number line (if present) so it can get its own icon row.
  const parseBranch = (raw) => {
    const clean = (raw || "")
      .replace(/&nbsp;/g, " ")
      .replace(/<\/?[^>]+(>|$)/g, "")
      .trim();

    const lines = clean.split("\n").map((l) => l.trim()).filter(Boolean);
    const phonePattern = /^[+()\d][\d\s()+-]{6,}$/;

    let phone = null;
    let addressLines = lines;

    if (lines.length && phonePattern.test(lines[lines.length - 1])) {
      phone = lines[lines.length - 1];
      addressLines = lines.slice(0, -1);
    }

    return { address: addressLines.join(", "), phone };
  };

  return (
    <section className="branches-section">
      <div className="branches-heading">
        <p className="eyebrow">OUR NETWORK</p>
        <h2>Our Branches</h2>
        <p className="lead-text">We are present across multiple locations to serve you better.</p>
      </div>

      <div className="row">
        {Address.map((Data, index) => {
          const { address, phone } = parseBranch(Data.info_paragraph);
          return (
            <div className="col-md-6 col-sm-12 branch-col" key={index}>
              <div className="branch-card">
                <div className="branch-card-top">
                  <span className="branch-number">{String(index + 1).padStart(2, "0")}</span>
                  <h4>{Data.info_title}</h4>
                  <span className="branch-building-icon">
                    <BuildingIcon />
                  </span>
                </div>

                <p className="branch-address">{address}</p>

                {phone && (
                  <div className="branch-phone">
                    <PhoneIcon size={16} />
                    <span>{phone}</span>
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}

export default Branches;